module.exports = __webpack_public_path__ + "img/glyphicons-halflings-regular.woff2?448c34a56d699c29117adc64c43affeb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/bootstrapv3/fonts/glyphicons-halflings-regular.woff2
// module id = 587
// module chunks = 0